
import { axios } from "../axios.instance";

export type AccountRequestResetPasswordRequest = null;

export type AccountRequestResetPasswordResponse = {
  waitMs: number;
  otpSentAt: string;
};

export const accountRequestResetPassword = async (): Promise<AccountRequestResetPasswordResponse> => {
  const { data } = await axios.post("auth/account/request-reset-password",);

  return data;
};
